import { Component, OnInit } from '@angular/core';
import { SongVM, SongsService } from './songs.service';
import { Observable } from 'rxjs';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-songs',
  templateUrl: './songs.component.html',
  styleUrls: ['./songs.component.css']
})
export class SongsComponent implements OnInit {
  songsList = new Observable<SongVM[]>;

  constructor(private songsService: SongsService, private metaManager: MetamanagerService){
    new InitScripts().loadScripts();
  }

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Mahanubhav Songs Gallery | Free Download | sarvadhnya.com",
      "Mahanubhav Panth songs free download, play online ",
      "Mahanubhav Panth songs, Mahanubhav songs, Mahanubhav Panth songs free download, play online, Chakradhar swami sthan, Mahanubhav songs gallery");

    this.songsList = this.songsService.get();
  }
}
